//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "MalinasScore",
  data() {
    return {
      form: {
        pregnancyFrequency: "",
        durationOfLaborPain: "",
        contractions: "",
        contractileSeptum: "",
        amnioticFluid:"",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "1次" },
        { value: "1", name: "2次" },
        { value: "2", name: "3次及以上" },
      ],
      dataList2: [
        { value: "0", name: "3h以下" },
        { value: "1", name: "3~5h" },
        { value: "2", name: "6h及以上" },
      ],
      dataList3: [
        { value: "0", name: "1min以下" },
        { value: "1", name: "1min" },
        { value: "2", name: "1min以上" },
      ],
      dataList4: [
        { value: "0", name: "5min以上" },
        { value: "1", name: "3~5min" },
        { value: "2", name: "3min以下" },
      ],
      dataList5: [
        { value: "0", name: "无" },
        { value: "1", name: "已经破裂" },
        { value: "2", name: "破裂时间超1h" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/MalinasScore.vue